import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import CreatableSelect from "react-select/creatable";
import { pageIndicator } from "../apollo";
import {
  ComponentTabLink,
  ITabLink,
  ITabTitle,
  PageType,
} from "../components/component-tab";
import { AsideAdminComponent } from "../layout/aside-admin";
import { FormError2 } from "../components/form-error";
import { Button } from "../components/button";
import {
  ICrCorporationFormProps,
  useCrCorporation,
} from "../hooks/useCrCorporation";
import { usePrompt } from "../constants/function";
import {
  CrCorporationInput,
  CrCorporationMutation,
} from "../generated/graphql";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { useListLinkServiceSelect } from "../hooks/useListLinkServiceSelect";
import { useListMainCategory } from "../hooks/useListMainCategory";

export const AdminCrCorporation = () => {
  
  const [
    listLinkServiceSelect,
    { data: linkservice },
  ] = useListLinkServiceSelect();

  // 1. useListMainCategory 훅의 반환값 구조에 맞게 수정
  const [listMainCategory, { data }] = useListMainCategory();

  useEffect(() => {
    // 2. 컴포넌트 마운트 시 카테고리 목록을 불러오도록 함수 호출 추가
    listLinkServiceSelect();
    listMainCategory();
  }, [listLinkServiceSelect, listMainCategory]); // 의존성 배열에 함수 추가



  const {
    getValues,
    setValue,
    setFocus,
    register,
    handleSubmit,
    watch,
    control,
    formState: { errors, isValid },
  } = useForm<ICrCorporationFormProps>({ mode: "all" });

  const onComplete = async (data: CrCorporationMutation) => {
    const {
      crCorporation: { ok, err },
    } = data;
    if (ok) {
      window.location.href = `/corporation/update/${data.crCorporation.createdId}`;
    } else {
      alert(err);
    }
  };
  const [crCorporation, { loading }] = useCrCorporation(onComplete);

  const onSubmit = () => {
    if (!loading) {
      const {
        phone,
        address,
        name,
        serviceId,
        mainCategory,
        operationFrom,
        operationTo,
        origin,
        holiday,
        deliveryLimitQuantity,
      } = getValues();
      let mainCategoryNames = [];
      if (mainCategory) {
        mainCategoryNames = mainCategory.map((category: any) => category.value);
      }
      const crCorporationInput: CrCorporationInput = {
        phone,
        address,
        name,
        serviceId: serviceId ? +serviceId : 1,
        // 3. category 객체에서 value 값만 추출하여 전달
        mainCategoryNames,
        operationFrom,
        operationTo,
        origin,
        holiday,
        deliveryLimitQuantity:
          deliveryLimitQuantity && !Number.isNaN(Number(deliveryLimitQuantity))
            ? Number(deliveryLimitQuantity)
            : null,
      };
      crCorporation({ variables: { input: crCorporationInput } });
    }
  };

  const tabList: ITabLink[] = [];
  const stitle: ITabTitle = { text: "거래처 등록" };
  const handlePostCode = (data: any) => {
    let fullAddress = data.address;
    let extraAddress = "";
    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
      setValue(`address`, fullAddress);
      setFocus(`address`);
    }
  };

  const scriptUrl =
    "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
  const open = useDaumPostcodePopup(scriptUrl);
  const handlerClick = () => {
    open({ onComplete: handlePostCode });
  };

  return (
    <div className="bg-main bg-opacity-50 w-full h-full min-h-screen">
      <div className="w-full mx-auto h-full min-h-screen bg-gray-100">
        <main id="main">
          <div className="grid grid-cols-[200px_1fr] max-w-full">
            <AsideAdminComponent />
            <div className="mypages bg-gray-100 w-full min-w-[1200px] overflow-hidden">
              <div className="orderWrap">
                <div className="h-fix-content relative">
                  <div className={`w-full h-full px-10 py-8`}>
                    <ComponentTabLink
                      tabs={tabList}
                      stitle={stitle}
                      type={PageType.Create}
                    />
                    <div className="shadow-lg w-full h-fix-content bg-white">
                      <form onSubmit={handleSubmit(onSubmit)} id="create">
                        <div className="pl-9 pr-11 py-8 space-y-4">
                          {/* ... 다른 input 필드들은 생략 ... */}
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              매장명
                            </p>
                            <input
                              {...register("name", {
                                required: `이름을 입력해주세요`,
                              })}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                            {errors.name?.message && (
                              <FormError2 errorMessage={errors.name.message} />
                            )}
                          </div>
                            
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              번호
                            </p>
                            <input
                              {...register("phone", {})}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                          </div>
                          <div className="w-full grid grid-cols-2 gap-4">
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              운영시간
                            </p>
                            <div className="flex flex-wrap items-center">
                    <input
                      {...register("operationFrom", {
                        required: `운영시간을 입력해주세요`,
                      })}
                      type="time"
                      className="border w-[calc(50%-12px)] h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                    />
                    <div className="w-[24px] text-center">~</div>
                    <input
                      {...register("operationTo", {
                        required: `운영시간을 입력해주세요`,
                      })}
                      type="time"
                      className="border w-[calc(50%-12px)] h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                    />
                  </div>
                  {errors.operationFrom?.message && (
                              <FormError2 errorMessage={errors.operationFrom.message} />
                            )}
                            {errors.operationTo?.message && (
                              <FormError2 errorMessage={errors.operationTo.message} />
                            )}
                          </div>
                          <div className="space-y-2 w-full">
                            <div className="space-y-2">
                              <p className="font-bold text-[#4F4F4F] text-base">
                                휴무일
                              </p>
                              <input
                                {...register("holiday", {})}
                                type="text"
                                className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                              />
                            </div>
                          </div>
                          </div>
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              서비스 지역
                            </p>
                            <select
                              {...register(`serviceId`, {
                                required: "서비스 ID를 선택해주세요",
                              })}
                              className="border w-full border-[#F0F0F4] rounded-lg py-1 px-2"
                            >
                              <option selected={true} disabled value="">
                                서비스를 선택해주세요
                              </option>
                              {linkservice?.listLinkServiceSelect.linkservice?.map(
                                (service) => (
                                  <option
                                    key={`service-${service.id}`}
                                    value={service.id}
                                  >
                                    {service.name}
                                  </option>
                                )
                              )}
                            </select>
                            {errors.serviceId?.message && (
                              <FormError2
                                errorMessage={errors.serviceId.message}
                              />
                            )}
                          </div>
    
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              <span className="pr-10">주소</span>
                              <button
                                className="py-2 px-4 border border-btnDarkLine rounded-lg text-btn text-grayFont"
                                type="button"
                                onClick={handlerClick}
                              >
                                우편번호찾기
                              </button>
                            </p>
                            <input
                              {...register("address", {})}
                              type="text"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                          </div>
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              원산지
                            </p>
                            <input {...register("origin", {})} type="text" className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4" />
                          </div>
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              배달 한도 수량
                            </p>
                            <input
                              {...register("deliveryLimitQuantity", {
                                valueAsNumber: true,
                              })}
                              type="number"
                              min={0}
                              placeholder="미입력 시 제한 없음"
                              className="border w-full h-10 border-[#F0F0F4] text-base rounded-lg py-1 px-4"
                            />
                            <p className="text-xs text-[#8B8C8C]">
                              한 번에 배송 가능한 수량입니다. 주문 수량이 이 수량을 초과할 때마다 배송비가 2,500원씩 추가됩니다. 비워두면 수량과 무관하게 기본 배송비(2,500원)만 부과됩니다.
                            </p>
                          </div>
                          <div className="space-y-2">
                            <p className="font-bold text-[#4F4F4F] text-base">
                              업종 카테고리
                            </p>
                            <Controller
                              name="mainCategory"
                              control={control}
                              render={({ field }) => (
                                <CreatableSelect
                                  {...field}
                                  isClearable
                                  // 4. 다중 선택이 가능하도록 isMulti prop을 추가합니다.
                                  isMulti
                                  options={data?.listMainCategory?.mainCategories?.map(
                                    (category) => ({
                                      value: category.name,
                                      label: category.name,
                                    })
                                  )}
                                  placeholder="업종을 선택하거나 직접 입력하세요..."
                                  formatCreateLabel={(inputValue) =>
                                    `"${inputValue}" 새로 만들기`
                                  }
                                />
                              )}
                            />
                          </div>
                          <div className="flex flex-wrap justify-center pt-6">
                            <Button
                              className={`w-[240px] h-[40px] bg-[#3D3E49] text-white rounded-lg`}
                              canClick={true}
                              actionText={`등록`}
                              loading={loading}
                              color={"text-white"}
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
